exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".shortlisted-row{background-color:#e6ffed!important}h3{color:#2c3e50;margin-top:1rem}ul{margin-left:1rem}hr{margin:2rem 0}.table-responsive-child{max-height:300px}.w-90 .modal-dialog{max-width:90%!important;margin:0 auto!important}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-2a36d038","scoped":false,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/component/payment/slinePaymentSortFinalList.vue
// module id = 1465
// module chunks = 0